/* eslint-disable no-prototype-builtins */
var XPortal = XPortal || {};
XPortal.EditForm = (function () {
    var self = { subscriptions: {}, valueSeparator: "_#_" };
    self._fieldSelector = ".detail-field";
    self._drVisibleFieldSelector = ".detail-field:not(.dr-invisible)";
    self.EditFormParameters = function (selector, modelName) {
        const $editForm = $(selector).find(".edit-form").first();
        $editForm.data("modelName", modelName);
        const r = prepareReduxModel({ container: $editForm, model: Object.assign({ IsCreating: false }, XPortal.Utils.readJsonStr($editForm.attr("data-settings"))) });
        const modelPath = XPortal.Store.GetModelPath($(selector), modelName);
        return Object.assign({
            parentInfo: XPortal.Utils.hrefQuery(window.location, "parentInfo") ? XPortal.Utils.hrefQuery(window.location, "parentInfo") : null,
            modelName, modelPath, selector
        }, r.model);
    };

    self.getEventHandlerFor = function (elmnt, eventName) {
        var callback = elmnt.attr(eventName);
        callback = callback ? callback : $($.find("[" + eventName + "]")).attr(eventName);
        return callback = callback ? window["XPortal"]["EditForm"][callback] : false;
    };
    self.Reloaded = function (selector, oncallback, modelName, extramodel) {
        const btitle = jQuery(selector).find(".edit-form-head").attr("data-title") || "";
        if (btitle.length) document.title = btitle;
        modelName = modelName ? modelName : XPortal.Store.getModelName(selector);
        const model = Object.assign(extramodel || {}, self.EditFormParameters(selector, modelName));
        if (!model) return;
        model.WasValidated = false;
        const { Alias, IsCreating, UniqueId, Keys } = model;
        const entity = { Alias, IsCreating, UniqueId, Fields: self.PrepareReduxFields($(selector)), Keys };
        model.Fields = Object.assign([], entity.Fields);
        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.EDIT_FORM_INITIALIZED, formParameters: model });
        XPortal.Grid.MapEntity(entity, null);

        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName, entity: entity, model });
        init(selector, modelName);
        if (XPortal.FEditor) {
            XPortal.FEditor.InitEditors(selector);
            XPortal.FEditor.AjaxUpdated(selector);
        }
        if (oncallback) oncallback();
        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.LOADED_ENTITY, model: modelName, entity, field: { field: "*" } });
    };
    self.PopupReloaded = function (iselector, oncallback) {
        modelName = iselector.replace("#", "").trim();
        executeSafely(self.Reloaded, iselector, oncallback, modelName, { isPopup: true });
        $(iselector).closest(".popup-detail-content").trigger(XPortal.Redusers.ACTIONS.LOADED_ENTITY);
    };
    self.StartAutoSave = function (modelName) {
        const state = XPortal.Store.GetBaseReduserState();
        const currentModel = state.pageModels[modelName];
        const container = $(currentModel.model.selector);
        const containerWithActions = (currentModel.isPopup) && container.closest(".modal-content").length ? container.closest(".modal-content") : container;
        const button = containerWithActions.find("[data-action=SaveDetail]");
        const isCreating = currentModel.model.IsCreating ? true : false;
        if (container.length < 1) return $.Deferred().resolve();
        if (!currentModel.itemsToSave || currentModel.itemsToSave.length < 1) return $.Deferred().resolve();

        const options = { modelName, container, button, notClose: true, silentMode: true, doNotDisplayErrors: isCreating, IsCreating: isCreating };
        return self.SaveData(modelName, options);
    };
    self.ValidateModel = function (modelName, options, fieldClass, skipClass) {
        options = GetOptions(modelName);
        const r = new $.Deferred();
        const pModel = XPortal.Store.GetModelByName(modelName);
        if (!pModel.model) return r.reject();
        const container = pModel.model.selector ? $(pModel.model.selector) : $("[id=detail-" + pModel.model.NodeId + "]");
        if (container.length < 1) return r.resolve();
        options.modelName = options.modelName || modelName;
        return self.ValidateTask(container, fieldClass || ".detail-field", options, skipClass);
    };
    function subscribeStaticText(modelName, container) {
        const model = XPortal.Store.GetModelByName(modelName);
        container.find("[data-metadata-fieldname]").each((ix, x) => {
            const el = $(x);
            if (el.is(".field-ex-format") || el.attr("data-editable") == "1") return;
            const xvalue = XPortal.Template.TemplateToHtml(model.entity, `[[${el.attr("data-metadata-fieldname")}]]`);
            const isEmptyAction = !xvalue || !xvalue.length ? "addClass" : "removeClass";
            if (!el.is(":input")) {                
                if (el.text().trim() != xvalue) {
                    el.text(xvalue);
                    el[isEmptyAction]("empty-value-line");
                    el.attr('title', xvalue);
                }
            }
        });
    };

    function initExFormatEditable(selector, modelName) {
        var isOver = false;
        $(selector || "body").on("click", ".has-ex-format-editable", (e) => {
            e.stopPropagation();
            if (e.target.classList.contains('icon-question') || e.target.classList.contains('fr-tooltip')) return;
            const $this = $(e.currentTarget);
            const $feditor = $this.find(".field-editor");
            const $input = $feditor.find("input");
            const strLength = $input.val().length * 2;
            $feditor.removeClass("d-none");
            if ($input.attr('type') == 'text') {
                $input[0].setSelectionRange(strLength, strLength);
            }
            $input.focus();
            $this.find(".field-ex-format").addClass("d-none");
            $input.on("mouseenter", function () { isOver = true; })
                .on("mouseleave", function () { isOver = false; });
        }).on("focusout", ".has-ex-format-editable", (e) => {
            if (!isOver) {
                const $this = $(e.currentTarget);
                $this.find(".field-editor").addClass("d-none");
                $this.find(".field-ex-format").removeClass("d-none");
            }
        });
    };

    function init(selector, modelName) {
        selector = selector ? selector : XPortal.Main.DetialFormSelector;
        var container = $(selector);
        executeSafely(XPortal.DynamicFilters.Init, container);
        executeSafely(XPortal.Main.InitEditControls, container, true);
        executeSafely(XPortal.EditActions.Init, { container, modelName });
        executeSafely(subscribeForStoreChanges, selector, modelName);
        XPortal.Store.ForceCloseForm(true);
        executeSafely(XPortal.Validation.ParseElementsIn, container, XPortal.Main.GetChildOrParentForm(container));
        executeSafely(XPortal.Dashboard.Init, selector, modelName);
        executeSafely(initExFormatEditable, selector, modelName);
        executeSafely(XPortal.Main.MapBreadcrumb, selector, modelName);
    };
    function executeSafely(onAction, ...args) {
        try {
            return onAction(...args);
        } catch (ex) {
            if (console) console.error(ex);
        }
    };
    self.IsDirty = function () {
        if (self.changesAlreadyRejected) {
            return false;
        }
        var editParams = XPortal.Store.GetState().editParameters;
        return editParams
            ? editParams.IsCreating || editParams.IsChanged
            : false;
    };
    self.SaveInProgress = function () {
        var form = $(XPortal.Main.DetialFormSelector);
        if (!form.length) {
            return false;
        }

        var modelName = XPortal.Store.getModelName(form);
        var state = XPortal.Store.GetBaseReduserState();
        var currentModel = state.pageModels[modelName];
        return currentModel && currentModel.SaveInProgress;
    };
    self.ValidateTask = function (container, fieldClass, options, skipClass) {
        container = container || $(XPortal.Main.DetialFormSelector);
        var frm = container.find(".edit-form");

        if (frm.length < 1) frm = $(".edit-form");
        return XPortal.Utils.ValidateForm(container.find(fieldClass || self._drVisibleFieldSelector), frm, options, skipClass);
    };
    self.SaveData = function (modelName, options, fieldClass, skipClass, skipPopupActionCompleted) {
        const anyform = $(XPortal.Main.DetialFormSelector);
        if (!modelName) modelName = options.modelName ? options.modelName : (anyform.length ? XPortal.Store.getModelName($(XPortal.Main.DetialFormSelector)) : null);
        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_START, modelName });
        const deferredSave = $.Deferred();
        const pModel = XPortal.Store.GetModelByName(modelName);
        const container = pModel.model.selector ? $(pModel.model.selector) : $("[id=detail-" + pModel.model.NodeId + "]");
        const frm = container.find(".edit-form");
        const $fields = container.find(fieldClass || self._fieldSelector);
        const fdata = frm.serializeArray();
        self.ValidateTask(container, fieldClass || ".detail-field", options, skipClass).then(function () {
            XPortal.Utils.EnsureCollectionDefer("before-save", function adjustEvent(e) {
                e.form = frm;
                e.data = fdata;
                return e;
            }, $fields).then(function () {
                saveEntityHierarchy(frm, options, pModel).then(
                    function (...args) {
                        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_END, modelName, saved: true });
                        self.ShowServerErrorMessages(args);
                        if (pModel.model.isPopup && !skipPopupActionCompleted) XPortal.EditActions.popupActionCompleted(options, "SaveDetail");
                        deferredSave.resolve(...args);
                    },
                    function (...args) {
                        if (console) console.warn('saveEntityHierarchy - error!', args);
                        XPortal.Loader.hide({ 'selector': null });
                        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_END, modelName, saved: false });
                        self.ShowServerErrorMessages(args);
                        deferredSave.reject(...args);
                    }
                );
            });
        }, function () {
            XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_END, modelName, saved: false });

            XPortal.Store.GetEditEntityToSave(true);
            XPortal.GridInlineEditing.ValidateAllGridModels();
            if (options && options.button) XPortal.Loader.hide({ selector: options.button });

            let $invalidFields = $fields.filter(function (i, field) { return $(field).hasClass('input-validation-error') });
            let validationErrors = $.map(_.groupBy($.map($invalidFields, function (field) {
                let $field = $(field);

                let $parent = $field.closest(".form-group");
                let valMsg = $parent.find('.field-validation-error');
                let validationError = valMsg.text() || "";

                let labels = $parent.find('label');
                let fieldShownName = (labels.text() || "").replace('*', '').replace('?', '').trim();
                return { f: fieldShownName, e: validationError };
            }), function (x) { return x.f; }), function (x) {
                var d = _.uniq(_.map(x, x => x.e), x => x).join("<br/>");
                return "<p>" + x[0].f + ": " + d + "</p>";
            });
            deferredSave.reject({ validationErrors: validationErrors });
        });
        return deferredSave.promise();
    };

    function saveEntityHierarchy(frm, options, model) {
        return new Promise((onOk, onError) => {
            showHideSaveEntityLoader(options, true);
            
            const entities = XPortal.Store.GetModelEntityToSave(false, model);
            const entityToSave = entities.length > 0 ? entities.pop() : null;
            const opts = { url: frm.attr('action') ? frm.attr('action') : '/umbraco/surface/detail/HandleSavedData', headers: XPortal.EditActions.FillHeaders({ container: frm }) };
            XPortal.GridInlineEditing.HandleSave(opts, { model: entityToSave }).then(function (state) {
                XPortal.EditActions.SaveDetailPopup(options, true);
                const result = state ? state.result : false;
                const data = result ? result.Result : false;
                if (result && !result.Errors && !(result.State < 0)) {
                    if (data && data.length > 0) {
                        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.ITEM_SAVE_SUCCESS, saveResult: data[0], entity: XPortal.Grid.MapEntity(data[0]), entityBefore: XPortal.Grid.MapEntity(XPortal.Store.ConvertSavedEntityToEdit(state.model)), modelName: model.model.modelName });
                        XPortal.Store.RefreshItemsForModel(model.model.modelName);
                    }
                } else {
                    if (result && result.Errors && result && !result.Errors.length) $("#errorBox").modal('show');
                    XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.ITEM_SAVE_FAIL, result: result, modelName: model.modelName });
                    return onError(result);
                }
                self.SaveChildsHierarchy(options, model).then(function () {
                    onOk((data && data.length > 0) ? true : false);
                    showHideSaveEntityLoader(options, false);
                }, function () {
                    showHideSaveEntityLoader(options, false);
                });
            }, function (data) {
                if (console) console.warn('XPortal.GridInlineEditing.HandleSave - error!' + model.modelName, data);
                XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.ITEM_SAVE_FAIL, result: data.result, modelName: model.modelName });
                XPortal.Loader.show({ showOverlay: true, color: "transparent", overlayBgColor: "rgba(0,0,0,0.5)" }).hide();
                showHideSaveEntityLoader(options, false);
                if (!data || !data.result) return $("#errorBox").modal('show');
                onError(data.result);
            });
        });
    };
    
    function showHideSaveEntityLoader(options, show) {
        if (!options || !options.button) return;

        var $buttonsToProcess = [];
        var $visibleBtns = options.button.filter(':visible');
        for (var i = 0; i < $visibleBtns.length; i++) {
            var $tempData = $($visibleBtns[i].closest('ul')).find(".lbl-save-state").filter(function () { return this.innerHTML == this.dataset.saveinprocess }).parent();
            if ($tempData.length) {
                $buttonsToProcess.push($visibleBtns[i]);
            }
        }
        if ($buttonsToProcess.length && show) return XPortal.Loader.show({ selector: $buttonsToProcess, bgcolor: '#aaaaaa', color: '#ffffff' });
        XPortal.Loader.hide({ selector: options.button });
    };
    function subscribeForStoreChanges(selector, modelName) {
        var s = self.subscriptions[modelName] = self.subscriptions[modelName] || { name: modelName, timeOut: 0, calcCntr: 0 };
        var store = XPortal.Store.AppStore;
        s.unsubscribe = s.unsubscribe || store.subscribe(() => {/*update calc field values*/
            var state = XPortal.Store.GetBaseReduserState();
            if (!state.pageModels.hasOwnProperty(modelName)) return;
            var laction = store.getState().lastAction;
            var mustContinue = s.timeOut == 0 && modelName.toLowerCase() == (laction.model || laction.modelName || "").toLowerCase();
            if (!mustContinue && !laction.field) return;
            if (!state.pageModels.hasOwnProperty(modelName)) return;
            subscribeStaticText(modelName, $(selector));
            if (isCalcFieldWereModified(state, modelName, laction)) return;

            clearTimeout(s.timeOut);
            s.timeOut = setTimeout(function () {
                var onEnd = () => self.updateExtendedFormating(modelName);
                self.updateCalcFieldsData(modelName, $(selector)).then(onEnd, onEnd);
            }, 500);
        });
    };

    self.SaveChildsHierarchy = function (options, model) {
        return new Promise((onOk, onErr) => {
            if (options && options.notClose) { //need to refresh updated items 
                XPortal.Store.SaveInlineItemsRefresh(true, false, model.modelName || (model.model ? model.model.modelName : null));
                onOk();
            } else XPortal.Store.SaveStoreItemsDefer(true, false, model.modelName || (model.model ? model.model.modelName : null)).then(onOk, onErr);
        });
    };
    self.DetailSucess = function (data) {
        XPortal.Utils.EnsureCollectionEvent("after-save", function (e) {
            e.form = frm;
            e.data = fdata;
            e.rdata = data;
            return e;
        }, frm.find(fieldClass), function () {
            if (frm.find(".detail-field-error").length < 1) {
                callback = XPortal.EditForm.getEventHandlerFor(frm, "data-ajax-ondone");
                if (callback && typeof callback === "function") callback.apply(this, data);
            }
        });
        if (data.Result) {
            $("#editFormSettings").data("uid", data.Result[0].UniqueEId);
            $("#editFormSettings").data("changed", false);
            $("#editFormSettings").data("creating", false);
            dfd.resolve(data);
        } else
            dfd.reject(data);

    };
    self.ShowErrorMessage = function (done, localizedMessage, localizedBody) {
        localizedBody = localizedBody || "";
        XPortal.Modal.alert({
            showModal: true,
            headerText: localizedMessage,
            alertText: done && done.Errors ? done.Errors.join() : done && done.validationErrors ? localizedBody + "<p>" + done.validationErrors.join("<br/>") + "</p>" : localizedBody
        });
    };
    self.ShowServerErrorMessages = function (dataArr) {
        if (!dataArr || dataArr.length < 1) return;
        var messages = [];
        dataArr.forEach(function (x) {
            (x.Messages || []).forEach(function (m) {
                if (m && m.State == -417)
                    messages.push(m.Message);
            });
        });
        if (messages.length > 0) {
            XPortal.Localization.GetLocalizedStrings("XFModal.Error.Title", "XFModal.Error.Save.Body").then(function (items) {
                XPortal.EditForm.ShowErrorMessage({ validationErrors: messages }, items["XFModal.Error.Title"] || "", items["XFModal.Error.Validation.Body"] || "");
            });
        }
    };
    self.CloseDetails = function () {
        //do not close if detail form must be opened
        if (XPortal.Store.ForceCloseForm()) {
            var breadcrumbItem = $("#breadcrumb-menu > li:nth-last-child(2) > a");
            if (breadcrumbItem.length > 0) {
                var url = breadcrumbItem.attr("href");
                self.SetBreadcrumbUrl({
                    url: url,
                    breadcrumbElement: breadcrumbItem[0]
                });
            } else {
                window.location.reload(true);
            }
        }
    };
    self.PrepareData = function ensureFormDataBeforeSend(data, sttgs) {
        var container = sttgs && sttgs.container ? $(sttgs.container) : $(".edit-form");
        var r = {
            Keys: [],
            Fields: [],
            UniqueId: sttgs.containerform.attr("uniqueid"),
            NodeId: sttgs.containerform.attr("entitydetailid"),
            EntityAlias: sttgs.containerform.attr("alias")
        };

        r.isCreating = $("#editFormSettings").data("creating");
        container.find(".detail-keyfield").each(function (ep, eldom) {
            var el = $(eldom);
            r.Keys.push({ field: el.attr("data-name"), data: el.val(), ftype: el.attr("data-type") });
        });
        r.Fields = self.ProcessDetailFields(container);
        return {
            model: r
        };
    };
    //model for redux
    function prepareReduxModel(sttgs) {
        const container = sttgs && sttgs.container ? $(sttgs.container) : $(".edit-form");
        const keys = [];
        container.find(".detail-keyfield").each(function (ep, eldom) {
            var el = $(eldom);
            keys.push({ field: el.attr("data-name"), data: el.val(), ftype: el.attr("data-type") });
        });
        return {
            model: Object.assign({
                Keys: keys,
                Fields: [],
                ParentInfo: XPortal.Utils.hrefQuery(window.location, "parentInfo")
            }, sttgs.model)
        };
    };

    self.PrepareReduxFields = function (container, className) {
        var fields = [];
        var searchPattern = className || self._fieldSelector;
        container.find(searchPattern).each(function (ep, eldom) {
            const el = $(eldom);
            const esttg = XPortal.Main.GetSettingsFor(el);
            esttg.ismultiselect = el.hasClass("xpand-multiselect");
            if (esttg.fieldname || esttg.type) {
                var fdata = {
                    Name: esttg.fieldname,
                    ftype: esttg.type,
                    Type: esttg.type,
                    editable: esttg.editable,
                    isChanged: el.data("IsChanged"),
                    ismultiselect: esttg.ismultiselect,
                    StringValue: esttg.value
                };

                fdata.StringValue = el.attr("value") ? el.attr("value") : el.data() && el.data().value ? el.data().value : fdata.StringValue;
                if (fdata.StringValue === "" && el.length > 0)
                    fdata.StringValue = el[0].value;
                fields = _.reject(fields, function (f) { return f.Name.toLowerCase() === fdata.Name.toLowerCase(); });
                fields.push(fdata);
            }
        });
        return fields;
    };

    self.ProcessDetailFields = function (container, className, useValueOnly) {
        var fields = [];
        var searchPattern = className || self._fieldSelector;
        container.find(searchPattern).each(function (ep, eldom) {
            var el = $(eldom);
            var fieldMetadata = {};
            $.each(_.filter(el[0].attributes, function (a) {
                return a.name.startsWith("data-metadata-");
            }), function (ix, a) {
                fieldMetadata[a.name.substring(14).toLowerCase()] = a.value;
            });
            var fdata = {
                field: fieldMetadata.fieldname,
                ftype: fieldMetadata.type,
                isChanged: el.data("IsChanged")
            };

            if (fdata.field) {
                if (fdata.ftype === "Date" || fdata.ftype === "DateTime") {
                    if (typeof ($(el)).getKendoDatePicker() != 'undefined') {
                        var dateTimeVal = $(el).getKendoDatePicker().value();
                        fdata.data = dateTimeVal === null ? '' : XPortal.Utils.customISOstring(dateTimeVal, dateTimeVal.getTimezoneOffset());
                    }
                } else if (fdata.ftype === "Boolean" && el.length > 0) {
                    fdata.data = el[0].checked === true ? 1 : 0;
                } else {
                    var elVal = el.val();
                    if (!useValueOnly && el.attr("data-value") && (!elVal) && el.attr("data-value")) elVal = el.attr("data-value");
                    fdata.data = elVal;
                }
                if (!Array.isArray(fdata.data)) { // since we can't convert string[] to string on .Net side we omit  arrays 
                    fields.push(fdata);
                }
            }
        });
        return fields;
    };
    //detail edit/save custom actions url changes
    self.ModifyUrlAfterNewRecordSave = function (url) {
        if (url.indexOf('new=') > -1) {
            var newId = XPortal.Utils.hrefQuery(url, 'new');
            var editParams = XPortal.Store.GetState().editParameters;
            if (newId && editParams && editParams.UniqueId) {
                url = url.replace('new=' + newId, "id=" + editParams.UniqueId);
            }
        }
        return url;
    };

    self.SetNewRecordLocationUrl = function (params, url) {
        if (!params)
            return;
        var kendoGrid = params.grid && params.grid.options ? params.grid : params.grid.data("kendoGrid");
        var d = kendoGrid && kendoGrid.options && kendoGrid.options.pageData ? kendoGrid.options.pageData.details : null;
        var gridId = kendoGrid.element.attr("data-id");
        var parentInfo = XPortal.Grid.dictionaryParent[gridId];
        d.parentInfo = parentInfo;
        var bc = self.PrepareBCstring(undefined, url);

        if (d && d.url && d.url.length > 0) {
            var linkTemplate = d.url + "?new=" + kendo.guid() +
                (d.parentInfo && d.parentInfo.length > 0 ? "&parentInfo=" + d.parentInfo : "") +
                XPortal.Main.BreadCrSep + encodeURIComponent(bc);
            window.location.href = linkTemplate;
        } else XPortal.Modal.alert({
            headerText: kendoGrid.options.messages.addnew.warningtitle,
            alertText: kendoGrid.options.messages.addnew.nodetaillinkfound
        });
    };
    self.SetMoveLocationUrl = function (params, url) {
        window.location = params.url;
    };
    self.SetBreadcrumbUrl = function (params) {
        var breadcrumbPart = params.breadcrumbElement.getAttribute("parsedpart");
        var index = params.breadcrumbElement.dataset.index;
        if (window.location.href.indexOf(breadcrumbPart) > -1) {
            var currentBCparts = XPortal.Utils.hrefQuery(window.location.href, "bc").split(",");
            currentBCparts.splice(index);
            let url = params.url + (currentBCparts.length > 0 ? (XPortal.Main.BreadCrSep + encodeURIComponent(currentBCparts.join(","))) : "");
            window.location = url.replace("/&", "/?"); //if we set BC for list item WO parameters
        } else
            window.location = params.url;
    };
    self.GetReturnNode = function () {
        var dashBoardElement = $("div.content.dashboard-page");
        var editForm = $(".detail-page .edit-form");
        let uid = null;
        let nodeId = null;
        if (dashBoardElement.length) {
            nodeId = dashBoardElement.find("div.row.fe-area").first()[0].id;
        } else if (editForm.length) {
            const modelName = XPortal.Store.getModelName(editForm.closest(".detail-page"));
            const model = XPortal.Store.GetModelByName(modelName);
            const entity = model ? model.entity : null;
            uid = entity ? entity.UniqueId.replace(/-/g, "") : null;
            nodeId = entity ? entity.NodeId : null;
        } else {
            var grid = $("div[id^='entity-grid-']");
            if (grid.length)
                nodeId = $("div[id^='entity-grid-']").data().id;
        }

        return { NodeId: nodeId, Uid: uid };
    };
    self.PrepareBCstring = function (nodeId, url) {
        if (url.indexOf(XPortal.Main.BreadCrSep.substr(1)) > -1) {
            bc = XPortal.Utils.hrefQuery(url, "bc");
        }
        var node = self.GetReturnNode();
        nodeId = nodeId || node.NodeId;
        if ($("#editFormSettings").length > 0 && $("#editFormSettings").data("creating")) {
            return (bc ? decodeURIComponent(bc) : "");
        }
        var curBc = (bc ? decodeURIComponent(bc) + XPortal.Main.BreadCrPartSep : "");
        if (curBc.split(",").length > 5) {
            var itms = curBc.split(",");
            curBc = itms.slice(itms.length - 6).join(",");
        }
        var bc = curBc + nodeId + (node.Uid ? XPortal.Main.BreadCrUidSep + node.Uid : "");
        return bc;
    };
    self.SetEditLocationUrl = function (params, bcUrl, activeRow) {
        var gridData = params.grid ? params.grid.data("kendoGrid") : undefined;
        var url = params.url ? params.url : gridData.options.pageData.details.url;
        var node = self.GetReturnNode();
        var nodeId = node.NodeId || (params.nodeId ? params.nodeId : gridData.options.pageData.nodeId);
        var parentInfo = gridData ? gridData.options.pageData.details.parentInfo : null;
        var bc = self.PrepareBCstring(undefined, bcUrl);
        if (params.uid) {
            var editedObjLink = XPortal.Template.ReplaceFormatString(url + "?id=" + params.uid +
                "&r=[[newguid]]" + (parentInfo && parentInfo.length > 0 ? "&parentInfo=" + parentInfo : ""), "", null, nodeId);
            if (params.returnUrlOnly)
                return editedObjLink;
            window.location = editedObjLink + XPortal.Main.BreadCrSep + encodeURIComponent(bc);
            return;
        }

        activeRow = activeRow ? activeRow : gridData.table.find("tr.k-state-selected");
        var selectedrows = XPortal.GridActions.GetXSelectedRows(params.grid);
        $(selectedrows).addClass("k-state-selected");

        if (activeRow.length === 0) {
            if (selectedrows.length > 0) {
                activeRow.push(selectedrows[0]);
            } else XPortal.Modal.alert({
                headerText: gridData.options.messages.sendmail ? gridData.options.messages.sendmail.warningtitle : "",
                alertText: XPortal.GridActions.GetWarningMsg(params.grid.closest(".grid-parent").find(".toolbar"))
            });
        }
        if (activeRow.length) {
            var editedObj = gridData.dataItem(activeRow[0]);
            var d = gridData.options.pageData ? gridData.options.pageData.details : null;
            if (d && d.url && d.url.length > 0) {
                editedObjLink = XPortal.Template.ReplaceFormatString(d.url + "?id=[[UniqueId]]&r=[[newguid]]" +
                    (parentInfo && parentInfo.length > 0 ? "&parentInfo=" + parentInfo : ""), "", editedObj, nodeId);
                if (params.returnUrlOnly)
                    return editedObjLink;
                window.location = editedObjLink + XPortal.Main.BreadCrSep + encodeURIComponent(bc);
            } else {
                XPortal.Modal.alert({
                    headerText: gridData.options.messages.edit.warningtitle,
                    alertText: gridData.options.messages.edit.nodetaillinkfound
                });
            }
        }
    };

    self.RegisterEvents = function (container) {
        //show confirmation message before move to any link
        $(container).on('click', 'a', function (e) {
            if ($(this).hasClass("open-in-dialog"))
                return self.ShowActionDialog(e, this, e.target);
            if (XPortal.Main.isNonActionLink(this, e.target))
                return;
            if ($('.fe-jscountdown-cntr').length)
                return;
            e.preventDefault();
            XPortal.GridActions.ShowPage({
                action: this.hasAttribute("parsedpart") ? XPortal.EditForm.SetBreadcrumbUrl : XPortal.EditForm.SetMoveLocationUrl,
                url: $(this).attr('href'),
                breadcrumbElement: this.hasAttribute("parsedpart") ? this : undefined
            });
        });
        $(container).on('click', '.tags-format-container .edit-tags, .detail-page .add-tag', function (e) {
            self.ShowTagsDialog(e, this, e.target);
            setTimeout(function () {
                XPortal.TagsEditor.$typeahead.typeahead('val', " ").trigger("focus");
                XPortal.TagsEditor.$typeahead.typeahead('val', '');
            }, 500);
        });
        $(container).on('change', '.detail-field[data-editable="1"]', function (e) {
            if (e.currentTarget) $(e.currentTarget).data("IsChanged", true);
            $("#editFormSettings").data("changed", true);
            //refresh dropdowns
            if (e.target && e.target.dataset.metadataFieldname)
                XPortal.Dropdown.updateFor(e.target.dataset.metadataFieldname, $(e.target).closest(XPortal.Main.DetialFormSelector));
        });

        $(container).on('click', 'a.alerts-show-all-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $sumBlock = $(e.currentTarget).closest(".alert-summary-content");
            $sumBlock.find(".alert-show-less").removeClass("d-none");
            $sumBlock.find(".alerts-show-all-btn").addClass("d-none");
            $sumBlock.find(".alerts-show-less-btn").removeClass("d-none");
        });
        $(container).on('click', 'a.alerts-show-less-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $sumBlock = $(e.currentTarget).closest(".alert-summary-content");
            $sumBlock.find(".alert-show-less").addClass("d-none");
            $sumBlock.find(".alerts-show-all-btn").removeClass("d-none");
            $sumBlock.find(".alerts-show-less-btn").addClass("d-none");
        });
    };
    self.ShowActionDialog = function (e, domEl, target) {
        if (e) e.preventDefault();
        const el = $(domEl);
        return getActionDialogPopupOpts(XPortal.Utils.readJsonStr(el.attr("data-dialog")), el.attr("href"))
            .then(function (opts) {
                const $modal = opts.popupObj.find(".modal-dialog");
                $modal.on("action-completed", function (e, argObj) {
                    XPortal.Modal.closeModal(null, opts.boxSelector || "#extended-popup-box");
                    $modal.trigger("refresh-org-grid");
                    $modal.trigger("refresh-entity", argObj);
                });
                $modal.on("refresh-entity", function (e, argObj) {
                    const refreshData = el.attr("data-refresh-data");
                    if (refreshData !== "1") return;
                    setTimeout(function () {
                        window.location.reload();
                    }, 300);
                });
                $modal.on("refresh-org-grid", function (e, argObj) {
                    let grid = el.closest(".grid-parent").find(".entity-grid");
                    if (!grid.length) grid = $("#entity-grid-" + el.attr("data-nodeid"));
                    if (grid.length) {
                        const ginfo = XPortal.Grid.GetGridInfo(grid);
                        ginfo.kgrid.dataSource.read();
                        ginfo.kgrid.refresh();
                    }
                });
            }, function (opts, ...args) { });
        //popupOpts.showStep(".wsection.finish");
    };
    function cleanUpPopupPageModels(e) {
        const $popup = $(e.currentTarget).find(XPortal.Main.DetialFormSelector);
        if (!$popup.length) return;
        const parentModelName = XPortal.Store.getModelName($popup.attr("id"));
        const state = XPortal.Store.GetState();
        for (var key in state.pageModels) {
            if (state.pageModels[key].model.modelPath && state.pageModels[key].model.modelPath.indexOf(parentModelName) >= 0)
                delete state.pageModels[key];
        }
    };
    self.ShowTagsDialog = function (e, domEl, target) {
        e.preventDefault();
        const el = $(domEl);
        const { opts, item } = XPortal.TagsEditor.PrepareTagsDialogOpts(el);
        if (!opts || !item) return;
        XPortal.TagsEditor.GetTagsDialogPopup(opts, item, el)
            .then(function (opts) {
                opts.popupObj.find(".modal-dialog").on("action-completed", function (e, argObj) {
                    XPortal.Modal.closeModal(null, "#extended-popup-box");

                    const model = XPortal.Store.GetModelByName(argObj.modelName).model;
                    const pageId = model.NodeId;
                    let grid = $("#entity-grid-" + pageId);
                    if (grid.length) {
                        const ginfo = XPortal.Grid.GetGridInfo(grid);
                        ginfo.kgrid.dataSource.read();
                        ginfo.kgrid.refresh();
                    }
                });
            }, function (opts, ...args) {
            });
    };

    function getActionDialogPopupOpts(opts, rurl) {
        opts.maxHeight = opts.maxHeight ? opts.maxHeight : opts.height;
        opts.strSettings = JSON.stringify(opts);
        opts.showStep = function (stepSelector, evnName) {
            opts.popupObj.find(".wsection").addClass("d-none");
            opts.popupObj.find(".modal-body-footer a").hide();
            opts.popupObj.find(stepSelector).removeClass("d-none");
            if (evnName) opts.popupObj.trigger(evnName);
        };

        opts.template = (opts.template || "").toLowerCase();
        opts.templateContainer = $("<div></div>");
        opts.templateContainer.html(XPortal.Template.TemplateToHtml(opts, $(opts.templateSelector || "#popup-detail-page").html()));
        opts.popupObj = XPortal.EditActions.initModalPopup($(opts.boxSelector || '#extended-popup-box'), opts, false, false, e => cleanUpPopupPageModels(e), true);
        return new Promise((onOk, onError) => {
            const content = opts.popupObj.find(".popup-detail-content");
            const cleanUpPopup = function () {
                const h1 = content.find("h1, .page-title-wrp");
                opts.popupObj.find(".modal-header .modal-title").html(h1.html());
                h1.detach().remove();
                const $btnsWrpr = content.find(".edit-btns-wrapper");
                $btnsWrpr.find(".detail-top-buttons-wrapper").removeClass("opacity-0").find(".dropdown").removeClass("d-none");
                $btnsWrpr.appendTo(opts.popupObj.find(".modal-footer"));
            };
            content.on(XPortal.Redusers.ACTIONS.LOADED_ENTITY, cleanUpPopup);
            const ajaxReq = {
                method: opts.ReqMethod || "POST", dataType: "html", cache: false, contentType: "application/json; charset=utf-8", url: XPortal.Utils.EnsureInProfile(rurl), data: kendo.stringify({}), headers: { "viewmode": "popup", "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
                success: function (xcontent) {
                    content.html(xcontent);
                    cleanUpPopup();
                    XPortal.Dashboard.Init(content);
                    XPortal.Grid.PreInit(content);
                    onOk(opts);
                },
                error: function (...args) {
                    onError(opts, args);
                }
            };
            $.ajax(ajaxReq);
        });
    };

    self.RegisterEvents(document);
    self.updateCalcFieldsData = function (modelName, container) {
        return new Promise(function (onOk, OnErr) {
            var model = XPortal.Store.GetModelByName(modelName);
            var uid = XPortal.Template.GetObjPropValueByName(model.entity, "uniqueid");
            var frm = container.find(".edit-form");
            var headers = XPortal.EditActions.FillHeaders({ container: frm });
            var calcFields = model.model.Schema.fields.filter(x => x.isCalc);
            if (calcFields && calcFields.length) {
                XPortal.Grid.ExecuteUpdateCalcFieldsData([uid], model.model.NodeId, { EntityAlias: model.model.Alias, parentInfo: model.model.ParentInfo }, headers)
                    .then(function (result) {
                        var item = result && result.Items ? result.Items.find(x => uid == XPortal.Template.GetObjPropValueByName(x, "uniqueid")) : null;
                        if (item) {
                            item = XPortal.Grid.MapEntity(item, null);
                            model = XPortal.Store.GetModelByName(modelName);
                            calcFields.forEach(f => {
                                const nl = XPortal.Template.GetObjPropName(model.entity, f.fieldName);
                                let nv = XPortal.Template.GetObjPropValueByName(item, f.fieldName);
                                nv = nv != null ? String(nv) : nv;
                                model.entity.Fields = model.entity.Fields || [];
                                let fe = model.entity.Fields.find(fi => fi.Name == f.fieldName);
                                if (!fe)
                                    entity.Fields.push(fe = { Name: afname, Type: action.field.ftype });

                                model.entity[nl] = fe.StringValue = nv;
                                XPortal.Store.DispatchWithoutEvents(modelName, f.fieldName, nv, true);
                            });
                        }
                        onOk();
                    }, OnErr);
            }
            else onErr();
        });
    };
    self.updateExtendedFormating = function (modelName) {
        return new Promise(function (onOk, OnErr) {
            var data = XPortal.Store.GetModelByName(modelName);
            if (!data || !data.model || !data.model.Schema) return;
            var withEFormat = data.model.Schema.fields.filter(x => x.formatExtended && x.formatExtended.Method);
            if (withEFormat.length < 1) onOk();
            var container = $(data.model.selector);
            var exformats = [];
            container.find(".field-ex-format").each((xi, x) => exformats.push(x));
            withEFormat.forEach(f => {
                if (f.id) f.id = f.id.toLowerCase();
                var exfrmt = exformats.find(ef => ($(ef).attr("data-cid") || "").toLowerCase() == f.id);
                if (!exfrmt) return;
                exfrmt = $(exfrmt);
                try {
                    loadFormatMethod(data.model, f, exfrmt);
                    exfrmt.html((f.funct) ? f.funct(data.entity, f.template, f) : "");
                } catch (e) {
                    exfrmt.html("");
                    if (console) console.log("updateExtendedFormating error", e);
                }
            });
        });
    };
    function isCalcFieldWereModified(state, modelName, laction) {
        if (!state || !state.pageModels) return false;
        var model = (state.pageModels[modelName] || {}).model;
        if (!model || !model.Schema) return false;
        if (!laction || !laction.field || !laction.field.field) return false;
        var field = (laction.field.field || "").toLowerCase();
        if (field == "*") return false;
        var isCalc = model.Schema.fields.filter(x => x.isCalc && x.fieldName.toLowerCase() == field);
        return isCalc && isCalc.length ? true : false;
    };
    function loadFormatMethod(model, field, container) {
        if (!field) return null;
        if (!field.template && field.template != '') field.template = (container.find("script").html() || "").trim();
        if (!field.funct) field.funct = new Function('item', 'htmlTemplate', 'fopts', 'return ' + field.formatExtended.Method + '(item, "' + field.type + '", "' + field.fieldName + '", null, ' + model.NodeId + ', htmlTemplate, fopts)');
        return field.funct;
    };
    function GetOptions(modelName) {
        const state = XPortal.Store.GetBaseReduserState();
        const currentModel = state.pageModels[modelName];
        const container = $(currentModel.model.selector);
        const containerWithActions = (currentModel.isPopup) && container.closest(".modal-content").length ? container.closest(".modal-content") : container;
        const button = containerWithActions.find("[data-action=SaveDetail]");
        const isCreating = currentModel.model.IsCreating ? true : false;
        return { modelName, container, button, notClose: true, silentMode: true, doNotDisplayErrors: true, IsCreating: isCreating };
    };

    return self;
}());
